import {
    CREATE_CANVAS,
    DISPOSE_CANVAS,
    DELETE_SELECTED_ITEMS,
    SAVE_CANVAS,
    setSelectedTool,
    startDrawingLine,
    stopDrawningLine,
    saveCanvasRequest
    } from '../actions'

import {isDrawingLine, getSelectedTool, getEditingInspectionId, getEditingVisitId} from '../selectors'
import {getAccountToken} from '../../../selectors'

import {fabric} from "fabric";
import forEach from 'lodash/forEach';
import first from 'lodash/first';
import {EDITOR_TOOLS} from'../../../models/enums'
import {getSecureImage} from '../../../utils/image'

var canvas = null;

class Canvas {

    canvas = null;
    store = null;
    scale = 1;
    file = null;

    constructor(store, payload) {

        const { file, elementId, height, width } = payload;

        this.file = file;
        this.store = store;

        this.canvas = new fabric.Canvas(elementId,
            {
                hoverCursor: 'pointer',
                backgroundColor: "transparent",
                height: height,
                width: width
            });

        this.canvas.on('mouse:up', this._onMouseUp);
        this.canvas.on('mouse:move', this._onMouseMove);
        this.canvas.on('object:selected', this._onObjectSelected);

        getSecureImage(getAccountToken(this.store.getState()), file.url)
            .then(blob => {
                fabric.Image.fromURL(URL.createObjectURL(blob), this._init, {crossOrigin: 'Anonymous'});
            });

        //fabric.Image.fromURL(file.url, this._init, {crossOrigin: 'Anonymous'});
    }

    dispose = () => {
        if(this.canvas) {
          this.canvas.dispose();
        }
        this.canvas = null;
    }

    deleteSelectedObjects = () => {
      if(!this.canvas) return;
      forEach(this.canvas.getActiveObjects(), item => {
          this.canvas.remove(item)
      });
      this.canvas.renderAll();
    }

    save = (inspectionId, visitId) => {
      const data = this.canvas.toJSON();
      const image = this.canvas.toDataURL({
          format: 'jpeg',
          quality: 0.9
      });

      var myBlob = new Blob([image], {type : "image/jpeg"});
      var fd = new FormData();
      fd.append('canvas', myBlob, 'canvas.jpg');
      fd.append('file', JSON.stringify({
          ...this.file,
          canvas_objects: JSON.stringify(data)
      }));

      this.store.dispatch(saveCanvasRequest(inspectionId, visitId, this.file.id, fd))
    }

    _init = (oImg) => {

      if(!this.canvas) return;

      var imageRation = oImg.width / oImg.height;
      var canvasRation = this.canvas.width / this.canvas.height;

      if (imageRation<canvasRation)
      {
          const scale = this.canvas.height / oImg.height
          this.canvas.setWidth( oImg.width * scale);
          this.canvas.setZoom(scale);
          this.scale = scale;
      }
      else
      {
          const scale = this.canvas.width / oImg.width
          this.canvas.setHeight( oImg.height * scale);
          this.canvas.setZoom(scale);
          this.scale = scale;
      }

      this.canvas.setBackgroundImage(oImg);

      if(this.file.canvas_objects) {
          var objects = JSON.parse(this.file.canvas_objects);
          const data = this.canvas.toJSON();
          objects.backgroundImage = data.backgroundImage;
          this.canvas.loadFromJSON(objects, () => {this.canvas.setBackgroundImage(oImg)});
      }
    }

    _onObjectSelected = (obj) => {

    }

    _onMouseMove = (obj) => {
      if(!this.canvas) return;
      const drawingLine = isDrawingLine(this.store.getState());
      if(drawingLine && this.line) {
          var point = this._convertToViewportPoint(obj);
          this.line.set({ 'x2': point.x, 'y2': point.y });
          this.canvas.renderAll();
      }
    }

    _onMouseUp = (e) => {
      if(!this.canvas) return;
      const tool = getSelectedTool(this.store.getState());
      switch(tool) {
          case EDITOR_TOOLS.redCircle: {
              this._createCircle(e, 'transparent', 'red', 4);
              break;
          }
          case EDITOR_TOOLS.greenCircle: {
              this._createCircle(e, 'rgba(0, 116, 0, 0.5)', 'transparent', 0);
              break;
          }
          case EDITOR_TOOLS.blueLine: {
              this._creatingLine(e, 'rgba(27, 125, 188, 0.8)', 'rgba(27, 125, 188, 0.8)', 4);
              break;
          }
          case EDITOR_TOOLS.purpleLine: {
              this._creatingLine(e, 'purple', 'purple', 4);
              break;
          }
          case EDITOR_TOOLS.orangeLine: {
              this._creatingLine(e, 'rgba(220, 130, 16, 0.8)', 'rgba(220, 130, 16, 0.8)', 4);
              break;
          }
          default:
              break;
      }
    }

    _convertToViewportPoint = (obj) => {
        const boundingRec = this.canvas.upperCanvasEl.getBoundingClientRect();

        if(obj.e.type === 'touchend') {
            const changedTouch = first(obj.e.changedTouches);
            if(changedTouch)
                return {
                    x: (changedTouch.clientX - boundingRec.left) / this.scale,
                    y: (changedTouch.clientY - boundingRec.top) / this.scale
                }
        }
        else {
            return {
                x: (obj.e.x - boundingRec.left) / this.scale,
                y: (obj.e.y - boundingRec.top) / this.scale
            }
        }

    }

    _createCircle = (obj, fill, stroke, strokeWidth) => {

        var radius = 50 /  this.scale;

        var point = this._convertToViewportPoint(obj);
        var circle = new fabric.Circle({
            top: point.y - radius,
            left: point.x - radius,
            radius: radius,
            stroke: stroke,
            fill: fill,
            strokeWidth: strokeWidth / this.scale,
            transparentCorners: false,
            cornerSize: 15
        });
        this.canvas.add(circle);
        this.canvas.renderAll();

        this.store.dispatch( setSelectedTool(EDITOR_TOOLS.pointer) );
    }

    _stopDrawingLine = (point) => {

        // There is a bug where the line will not be selectable after we draw it, so o create a new line and
        // remove the old line
        if(this.line) {
            var l = new fabric.Line([this.line.x1, this.line.y1,
                (point && point.x) || this.line.x2,
                (point && point.y) || this.line.y2,], {
                fill: this.line.fill,
                stroke: this.line.stroke,
                strokeWidth: this.line.strokeWidth,
                transparentCorners: false,
                cornerSize: 15
            });
            this.canvas.add(l);
            this.canvas.remove(this.line);
            this.line = null;
            this.canvas.renderAll();
        }
        this.store.dispatch( stopDrawningLine() );
    }

    _creatingLine = (obj, fill, stroke, strokeWidth) => {

        const drawingLine = isDrawingLine(this.store.getState());

        var point = this._convertToViewportPoint(obj);

        if(drawingLine) {
            this._stopDrawingLine(point);
            return;
        }

        this.line = new fabric.Line([point.x, point.y, point.x+50, point.y], {
            fill: fill,
            stroke: stroke,
            strokeWidth: strokeWidth / this.scale,
            transparentCorners: false,
            cornerSize: 15
        });

        this.canvas.add(this.line);
        this.canvas.renderAll();

        this.store.dispatch( startDrawingLine('line') );
    }

}

export default store => next => action => {

    switch(action.type) {
        case CREATE_CANVAS:

            if(canvas) {
                canvas.dispose();
                canvas = null;
            }

            canvas = new Canvas(store, action.payload)

            break;

        case DISPOSE_CANVAS:
            if(canvas) {
                canvas.dispose();
                canvas = null;
            }
            break;

        case DELETE_SELECTED_ITEMS:
            if(!canvas) return;
            canvas.deleteSelectedObjects();
            break;

        case SAVE_CANVAS:
            const state  = store.getState();
            canvas.save(getEditingInspectionId(state), getEditingVisitId(state));
            break;
        default:
            break;
    }

    return next(action)
}



// WEBPACK FOOTER //
// ./src/modules/vegetation/middleware/editorMiddleware.js